import React, { useEffect, useState } from 'react';
import styles from '../ModulosPagoSpei/pagoSpei.module.sass'

import HeaderMobileCredito from 'components/Header/HeaderMobileCredito'

import { ThanskPageSpei } from '../ModulosPagoSpei';


export default function PagoSpeiMovil(props) {

    const {
        clabe,
        payCode,
        payCard,
        handleFinalizar,
        isMobile
    } = props

    return (
        <>
            <HeaderMobileCredito logo="/credito-claroshop/img/newCredito/logo-claroshop.svg" type="backFullAction" action={handleFinalizar} />

            <div className={`container ${styles?.no_printme}`}>
                <div className={styles?.contCards}>

                    <ThanskPageSpei
                        clabe={clabe}
                        payCode={payCode}
                        payCard={payCard}
                        isMobile={isMobile}
                    />

                </div>
            </div>
        </>
    )
}